/** True when every whitespace-separated term of `query` occurs in `text`, ignoring case. */
export function matchesQuery(text: string, query: string): boolean {
  const haystack = text.toLowerCase()
  return query.toLowerCase().split(/\s+/).filter(Boolean).every((term) => haystack.includes(term))
}
